import { ColorTools } from './color.tools';


export class EmergencyTools {

  static backgroundColor(color: string): string {
    return ColorTools.HEXToRGBA(color, 0.1);
  }

  static border(color: string): string {
    return '2px solid ' + color;
  }
}
